import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sun, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
    return (
        <div className="min-h-screen pt-20 flex flex-col items-center justify-center bg-background relative overflow-hidden px-4">
            
            {/* Background Decorations */}
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" />

            {/* Content Container */}
            <motion.div 
                className="relative z-10 text-center max-w-2xl mx-auto"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                {/* Visual */}
                <motion.div 
                    className="flex justify-center mb-8 relative"
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20,
                        delay: 0.2
                    }}
                >
                    <div className="relative">
                        <Sun className="w-32 h-32 md:w-48 md:h-48 text-primary opacity-20 animate-pulse" />
                        <motion.div 
                            className="absolute inset-0 flex items-center justify-center"
                            initial={{ rotate: -10 }}
                            animate={{ rotate: 10 }}
                            transition={{ repeat: Infinity, repeatType: "mirror", duration: 4, ease: "easeInOut" }}
                        >
                            <span className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-600 drop-shadow-sm">404</span>
                        </motion.div>
                    </div>
                </motion.div>

                {/* Text Block */}
                <h1 className="text-3xl md:text-5xl font-bold mb-6 text-foreground tracking-tight">
                    Oops! Energy Disturbance Detected.
                </h1>
                
                <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed">
                    We can't seem to find the page you're looking for. It might have been moved, deleted, or perhaps the sun was in our eyes!
                </p>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Button asChild size="lg" className="h-12 px-8 w-full sm:w-auto hover:scale-105 transition-transform">
                        <Link to="/">
                            <Home className="w-5 h-5 mr-2" />
                            Return Home
                        </Link>
                    </Button>
                    
                    <Button asChild variant="outline" size="lg" className="h-12 px-8 w-full sm:w-auto bg-background/50 backdrop-blur hover:bg-muted/50 transition-colors">
                        <button onClick={() => window.history.back()}>
                            <ArrowLeft className="w-5 h-5 mr-2" />
                            Go Back
                        </button>
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default NotFoundPage;
